import React from 'react';
import { useIsFeatureEnabled } from '@innovyze/stylovyze';
import {
	AssetGrid as EsriAssetGrid,
	AssetGridProps,
} from '@Map/esri/features/AssetGrid/AssetGrid';
import { AssetGrid as MapComponentsAssetGrid } from '@innovyze/map-components';

/**
 * Feature-flag–driven AssetGrid wrapper.
 *
 * The props interface is identical between Esri and Mapbox implementations so
 * both receive the same props object.
 *
 * When `info360-platform-esri-map` is enabled the Esri implementation is
 * rendered; otherwise the legacy `@innovyze/map-components` version is used.
 */
const AssetGrid = (props: AssetGridProps): JSX.Element => {
	const isEsri = Boolean(useIsFeatureEnabled('info360-platform-esri-map'));

	if (isEsri) {
		return <EsriAssetGrid {...props} />;
	}

	return <MapComponentsAssetGrid {...props} />;
};

export default AssetGrid;
